import storeFront from '../../../assets/icons/sellerFirst/storeFront.svg';

import swal from '../../../assets/icons/sellerFirst/swal.svg';
import upl from '../../../assets/icons/sellerFirst/upl.svg';
import neptune from '../../../assets/icons/sellerFirst/neptune.svg';
import agrovet from '../../../assets/icons/sellerFirst/agrovet.svg';
import spraywell from '../../../assets/icons/sellerFirst/spraywell.svg';
import geolife from '../../../assets/icons/sellerFirst/geolife.svg';

import createAccount from '../../../assets/icons/sellerFirst/createAccount.svg';
import listProducts from '../../../assets/icons/sellerFirst/listProducts.svg';
import receiveOrders from '../../../assets/icons/sellerFirst/receiveOrders.svg';
import shipOrders from '../../../assets/icons/sellerFirst/shipOrders.svg';

import wideReach from '../../../assets/icons/sellerFirst/wideReach.svg';
import easeBusiness from '../../../assets/icons/sellerFirst/easeBusiness.svg';
import payoutIcon from '../../../assets/icons/sellerFirst/payoutIcon.svg';

const NUMBER_OF_RETAILERS = '100,000+';
const MONTHLY_SALES = '₹ 100 Cr';
const NUMBER_OF_STATES = '16';
const NUMBER_OF_BRANDS = '200+';
// const NUMBER_OF_PRODUCTS = '1000+';
// const NUMBER_OF_PINCODES = '10000+';

export const INFOs = [
  {
    image: storeFront,
    name: NUMBER_OF_RETAILERS,
    subName: 'Retailers',
  },
  {
    image: '../../assets/icons/sellerFirst/moneyBag.svg',
    name: MONTHLY_SALES,
    subName: 'monthly sales',
  },
  {
    image: '../../assets/icons/sellerFirst/indiaMap.svg',
    name: NUMBER_OF_STATES,
    subName: 'States',
  },
  {
    image: '../../assets/icons/sellerFirst/brands.svg',
    name: NUMBER_OF_BRANDS,
    subName: 'Brands',
  },
];

export const TOP_SELLERS = [
  {
    image: swal,
  },
  {
    image: upl,
  },
  {
    image: neptune,
  },
  {
    image: agrovet,
  },
  {
    image: spraywell,
  },
  {
    image: geolife,
  },
];
export const SELL_ON_NURTURE = [
  {
    image: createAccount,
    recordName: 'Create Account',
    recordDescription:
      'Register easily using your mobile number and basic business details',
    arrowImg: true,
  },
  {
    image: listProducts,
    recordName: 'List Products',
    recordDescription:
      'Simply select from our predefined product catalogue and start getting orders',
    arrowImg: true,
  },
  {
    image: receiveOrders,
    recordName: 'Get Orders',
    recordDescription:
      'Upload product details like inventory, pricing, etc. to start receiving orders from retailers',
    arrowImg: true,
  },
  {
    image: shipOrders,
    recordName: 'Ship Orders',
    recordDescription:
      'Dispatch products effortlessly through our partners to the retailer’s store and get paid on order fulfillment',
    arrowImg: true,
  },
];

export const SELLS_CHOOSE_US = [
  {
    image: wideReach,
    recordName: 'Wide Reach',
    recordDescription: `Access ${NUMBER_OF_RETAILERS} retailers across ${NUMBER_OF_STATES} states across India`,
  },
  {
    image: easeBusiness,
    recordName: `Ease of Business`,
    recordDescription: `List your products easily and enjoy stress-free delivery`,
  },
  {
    image: payoutIcon,
    recordName: 'Quick and Secure Payments',
    recordDescription:
      'Get instant payments to your bank account after order fulfilment',
  },
];
export const TESTIMONIALS = [
  {
    image: '../../assets/seller.png',
    name: 'Ram Sharma',
    location: 'Trivandrum, Kerala',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, risus odio diam sed ultricies integer. Aliquet enim sed egestas mattis porta orci sit. Cras in ipsum in tortor.
      Aenean parturient et id maecenas posuere molestie at in ac. Sapien in vulputate eu enim cursus. Tortor nec parturient felis facilisi. `,
  },
  {
    image: '../../assets/seller.png',
    name: 'Ram Sharma 1',
    location: 'Trivandrum, Kerala',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, risus odio diam sed ultricies integer. Aliquet enim sed egestas mattis porta orci sit. Cras in ipsum in tortor.
      Aenean parturient et id maecenas posuere molestie at in ac. Sapien in vulputate eu enim cursus. Tortor nec parturient felis facilisi. `,
  },
  {
    image: '../../assets/seller.png',
    name: 'Ram Sharma 2',
    location: 'Trivandrum, Kerala',
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lacus, risus odio diam sed ultricies integer. Aliquet enim sed egestas mattis porta orci sit. Cras in ipsum in tortor.
      Aenean parturient et id maecenas posuere molestie at in ac. Sapien in vulputate eu enim cursus. Tortor nec parturient felis facilisi. `,
  },
];

export const FAQs = [
  {
    id: 'q1',
    question: 'How do I register?',
    answer: `<p>Selling through SellerFirst is super easy.&nbsp;</p>
      <ul>
          <li>
              <p>You can complete registration by clicking on &lsquo;Start Selling&rsquo; and providing your basic information. If you need any help or more information, you can call our customer care team on&nbsp;18001021199</p>
          </li>
          <li>
              <p>Post-registration, you can directly access your account and select the products from our catalogue that you would like to sell.&nbsp;</p>
          </li>
          <li>
              <p>You can then list your inventory, set prices and activate your products. Voila! Retailers will now be able to view and purchase your products.</p>
          </li>
          <li>
              <p>Once the customer pays for your products, you can process the order by invoicing, packing and shipping. Our delivery team will assist you in delivering your order on time and without any hassle. </p>
          </li>
          <li>
              <p>Once the order is fulfilled and delivered, the amount will be immediately credited to your linked bank account.</p>
          </li>
      </ul>`,
  },
  {
    id: 'q2',
    question: 'What products can I sell?',
    answer: `<p>You can sell almost everything related to agri input products in the following categories:</p>
      <p>Insecticides, Fungicides, Herbicides, Seeds, Farm equipment, Cattle feed, Bio stimulants, Biofertilisers, Seed treatment, Crop nutrition, post-harvest solutions and soil health products.</p>`,
  },
  // {
  //   question: "What details do I need to share to register as a seller?",
  //   answer: `<p>You will need the following information to register.</p>
  //     <ul>
  //         <li>
  //             <p>Your business details like state/s of operation, categories you sell and yearly revenue.</p>
  //         </li>
  //         <li>
  //             <p>Your contact details&mdash;email and phone number</p>
  //         </li>
  //         <li>
  //             <p>Tax Registration Details (PAN and GST) and cancelled cheque copy. GST Details are mandatory if you are listing taxable goods and would like to claim a tax credit for the same.&nbsp;</p>
  //         </li>
  //     </ul>`,
  // },
  {
    id: 'q3',
    question:
      'How will my products get shipped to the customer?',
    answer: `<p>You can either opt for self delivery in which case you can deliver using your own transportation or for a hassle free experience you can choose to deliver using our delivery fleet for free of charge. Our delivery person will come to your establishment to pick up the products once you invoice them, and he will handle the final mile delivery to the customer’s doorstep. </p>`,
  },
  {
    id: 'q4',
    question:
      'What are the charges for selling on sellerFirst?',
    answer: `<div>
      <div>
          <p>Listing on nurture.retail is completely free of charge. We only charge you a small commission fee when you get an order. Below are the details:</p>
          <div align="left">
              <table>
                  <tbody>
                      <tr>
                          <td>
                              <p>&nbsp; &nbsp;<strong>&nbsp;</strong><strong>Category </strong>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
                          </td>
                          <td>
                              <p>&nbsp; &nbsp;<strong>&nbsp;</strong><strong>&nbsp;*Commission &nbsp; </strong>&nbsp; &nbsp;</p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>&nbsp; &nbsp; Crop Protection</p>
                          </td>
                          <td>
                              <p>&nbsp; &nbsp; &nbsp; 8-10%</p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>&nbsp; &nbsp; Crop Nutrition</p>
                          </td>
                          <td>
                              <p>&nbsp; &nbsp; &nbsp; 10-12%</p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>&nbsp; &nbsp; Seeds</p>
                          </td>
                          <td>
                              <p>&nbsp; &nbsp; &nbsp; &nbsp;8-10%</p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>&nbsp; &nbsp; Cattle feed</p>
                          </td>
                          <td>
                              <p>&nbsp; &nbsp; &nbsp; &nbsp; 7-8%</p>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <p>&nbsp; &nbsp; Farm Implements</p>
                          </td>
                          <td>
                              <p>&nbsp; &nbsp; &nbsp; &nbsp; 12-15%</p>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
          <p><span style="color: rgb(0, 0, 0);"><strong>*</strong></span>Please note that above rates are only indicative and you can contact us on&nbsp;</p>
          <p>18001021199 to get the best rate as per your profile.&nbsp;</p>
          <p><br></p>
      </div>
  </div>`,
  },
  {
    id: 'q5',
    question: 'When and how would I get paid?',
    answer: `<p>We (nurture.retail) will directly credit the bank account that you provide during registration post customer confirmation of order delivery.&nbsp;</p>`,
  },
  // {
  //   question: "How do I list my products on SellerFirst ?",
  //   answer: `<p>You can list products in bulk through uploading your inventory in an Excel file to the &lsquo;My Catalogue&rsquo; tab. The procedure and information required will vary depending on whether your products are already in our catalogue or if you want to list a new product. Once you complete your registration, you will be guided on the steps needed to list your products.&nbsp;</p>`,
  // },
  // {
  //   question: "How do I manage my orders on SellerFirst?",
  //   answer: `<p>You can view your orders and manage them through the &ldquo;<a href="https://retail.nurture.farm/orders">Order History</a>&rdquo; tab. If you are using Fulfilment through nurture.retail, your orders will be fulfilled and shipped by nurture.retail. If you are using Easyship, you can pack your orders, and our team will schedule your pickup and do the subsequent delivery.</p>`,
  // },
  // {
  //   question: "How and who will do invoicing for the orders that I receive?",
  //   answer : `<p>You can now chill! All your invoicing needs will be taken care of by us. We can generate e-invoice on your behalf or bill of supply depending on your products, and will also share details with you so that you can reconcile your systems if needed. In case you wish to invoice by yourself, we provide flexibility for you to do the same and upload the invoice copy on our system. </p>`
  // },
  // {
  //   question: "How do I download reports on my order history, inventory etc?",
  //   answer: `Access to reports is very simple. You can go to the relevant tab in SellerFirst and every tab has a custom report option. For example, under ‘Order history’, you can click on the ‘Export’ button and specify your custom criteria like date range etc. and click on download report.`,
  // },
];

export const SELLER_STORIES = [
  {
    storyHeader: 'Seller Success Stories',
    storyDescription:
      '“Our sales turnover from SellerFirst was ₹6-7 cr in the last 6 months.”',
    sellerHeader: 'Ajay Gupta',
    sellerInfo: 'Director, Gupta Enterprises',
    link: 'https://youtu.be/0oXm96aWwog',
  },
  {
    storyHeader: 'Seller Success Stories',
    storyDescription:
      '“We are now able to sell our own brand. This has always been our top priority.”',
    sellerHeader: 'Samarth Badjatiya',
    sellerInfo:
      'Director, Bharat Feeds and Extractions Ltd',
    link: 'https://youtu.be/eJhKBHa7qsM',
  },
  {
    storyHeader: 'Seller Success Stories',
    storyDescription:
      '“It helps us reach customers in small villages that our sales team and dealer network cannot.”',
    sellerHeader: 'Rahul Masand',
    sellerInfo: 'Director, Masand Agro Equipments Pvt Ltd',
    link: 'https://youtu.be/0rxxuytSI0c',
  },
];

export const TESTIMONIAL_FOOOTER = `SellerFirst empowers brands and distributors to reach over ${NUMBER_OF_RETAILERS} retailers on nurture.retail, India’s largest online marketplace for agri-input retailers to buy crop protection products, fertilisers, nutrition and biological products, farming equipment, seeds and cattle feed directly from these brands or distributors.`;
